import React from "react";
import styles from "./Footer.module.css";
import { Container, Row, Col, Image, Card } from "react-bootstrap";
import homecare from "../assets/Home-care-logo.png";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaLocationCrosshairs } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa";
import { IoLogoTwitter } from "react-icons/io";
import { BsInstagram } from "react-icons/bs";
import { IoLogoYoutube } from "react-icons/io";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <div className={styles.containerFooter}>
      <div className={styles.desktopFooter}>
        <Container>
          <Row>
            <Col md={6} className={styles.colFooter1}>
              <Image src={homecare} style={{ width: 140, height: 60 }} />
              <p className={styles.textFooter}>
                it is a long established fact that a reader will be distracted
                by the readable content of a page when looking at its layout.
                The point of using Lorem Ipsum is that it has a more-or-lesssw
                normal distribution of letters, as opposed to using 'Content
                here, content here', making it look like readable English.{" "}
              </p>
              <Row style={{ width: "100%", marginTop: 10 }}>
                <Col
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <FaPhoneAlt size={25} color="#07448E" />
                  <p style={{ marginTop: 10 }}>+91 1234567890</p>
                </Col>
                <Col
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}>
                  <MdEmail size={25} color="#07448E" />
                  <p style={{ marginTop: 10 }}>info@example</p>
                </Col>
                <Col
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <FaLocationCrosshairs size={25} color="#07448E" />
                  <p style={{ marginTop: 10 }}>Location </p>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Image
                    src={
                      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Google_Play_Store_badge_EN.svg/2560px-Google_Play_Store_badge_EN.svg.png"
                    }
                    style={{ width: 180, height: 55 }}
                  />
                </Col>
                <Col>
                  <Image
                    src={
                      "https://cmsphoto.ww-cdn.com/superstatic/129568/art/grande/79767595-57712201.jpg?v=1713969716.0553339"
                    }
                    style={{ width: 180, height: 55 }}
                  />
                </Col>
              </Row>
            </Col>
            <Col md={6}>
              <Row>
                <Col md={6}>
                  <h4
                    style={{
                      color: "#07448E",
                      fontFamily: "'Inter', sans-serif",
                    }}
                  >
                    Quick Link
                  </h4>
                  <ul style={{ listStyle: "none", padding: 0 }}>
                    <li>
                      <Link
                        to="/"
                        style={{ textDecoration: "none", color: "#000" }}
                      >
                        HOME
                      </Link>
                    </li>
                    <li style={{ marginTop: 10 }}>
                      <Link
                        to="/about"
                        style={{ textDecoration: "none", color: "#000" }}
                      >
                        ABOUT
                      </Link>
                    </li>
                    <li style={{ marginTop: 10 }}>
                      <Link
                        to="/services"
                        style={{ textDecoration: "none", color: "#000" }}
                      >
                        SERVICES
                      </Link>
                    </li>
                    <li style={{ marginTop: 10 }}>
                      <Link
                        to="/offer"
                        style={{ textDecoration: "none", color: "#000" }}
                      >
                        OFFER
                      </Link>
                    </li>
                    <li style={{ marginTop: 10 }}>
                      <Link
                        to="/blog"
                        style={{ textDecoration: "none", color: "#000" }}
                      >
                        BLOG
                      </Link>
                    </li>
                    <li style={{ marginTop: 10 }}>
                      <Link
                        to="/contact"
                        style={{ textDecoration: "none", color: "#000" }}
                      >
                        CONTACT
                      </Link>
                    </li>
                    <li style={{ marginTop: 10 }}>
                      <Link
                        to="/privacy-policy"
                        style={{ textDecoration: "none", color: "#000" }}
                      >
                        PRIVACY POLICY
                      </Link>
                    </li>
                    <li style={{ marginTop: 10 }}>
                      <Link
                        to="/termAndCondition"
                        style={{ textDecoration: "none", color: "#000" }}
                      >
                        TERMS & CONDITIONS
                      </Link>
                    </li>
                  </ul>
                </Col>
                <Col
                  md={6}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <button
                    style={{
                      padding: 10,
                      border: "none",
                      fontFamily: "'Inter', sans-serif",
                      background: "#07448E",
                      color: "#fff",
                      borderRadius: 10,
                    }}
                  >
                    JOIN AS A PARTNER
                  </button>

                  <h6
                    style={{
                      color: "#07448E",
                      fontFamily: "'Inter', sans-serif",
                      marginTop: 25,
                    }}
                  >
                    Follow Us On
                  </h6>
                  <ul
                    style={{
                      marginTop: 10,
                      fontFamily: "'Inter', sans-serif",
                      listStyle: "none",
                    }}
                  >
                    <li>
                      <FaFacebookF /> Facebook
                    </li>
                    <li style={{ marginTop: 10 }}>
                      <BsInstagram color="#07448E" /> Instagram
                    </li>
                    <li style={{ marginTop: 10 }}>
                      <IoLogoTwitter color="#07448E" /> Twitter
                    </li>
                    <li style={{ marginTop: 10 }}>
                      <IoLogoYoutube color="#07448E" /> Youtube
                    </li>
                  </ul>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
        <br></br>
        <div
          style={{
            height: 60,
            background: "#07448E",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p
            style={{
              color: "#fff",
              fontFamily: "'Inter', sans-serif",
              marginTop: 20,
              fontSize: 13,
            }}
          >
            Copyright © 2025 House Care Online - All Rights Reserved{" "}
          </p>
        </div>
      </div>
      <div className={styles.mobileFooter}>
        <div style={{display:"flex",justifyContent:"space-between",width:"100%"}}>
  <Image
    src={
      "https://static.vecteezy.com/system/resources/previews/024/170/871/non_2x/badge-google-play-and-app-store-button-download-free-png.png"
    }
    className={styles.androidClass}
  />

  <Image
    src={
      "https://cmsphoto.ww-cdn.com/superstatic/129568/art/grande/79767595-57712201.jpg?v=1713969716.0553339"
    }
    className={styles.iosClass}
  />
  </div>

  {/* 🔹 Social Media Icons for Mobile Footer */}
 <div className={styles.socialIconsMobile}>
    <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
      <FaFacebookF />
    </a>
    <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
      <BsInstagram />
    </a>
    <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
      <IoLogoTwitter />
    </a>
    <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
      <IoLogoYoutube />
    </a>
  </div>
</div>
    </div>
  );
}
